'use client'
import React, { useCallback, useEffect, useRef, useState } from 'react'

// import 'bootstrap/dist/css/bootstrap.min.css'
import { DownArrow, LogoIcon, NavRightArrow } from '@/svgs'
import Script from 'next/script'
import { usePathname } from 'next/navigation'
import Link from 'next/link'

const technologiesData = [
   {
      id: 'ai-ml',
      title: 'AI/ML',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/Custom-Chatbot.svg',
            alt: 'Custom Chatbot',
            href: '/technologies/ai-ml/ai-chatbot-development-services',
            title: 'Custom Chatbot',
            description:
               'Enhance user engagement with AI-driven chatbots that provide instant, intelligent, and human-like responses.',
         },
         {
            icon: '/assets/svg/Model-Training.svg',
            alt: 'Model Training',
            href: '/technologies/ai-ml/ai-model-training-services',
            title: 'Model Training',
            description:
               'Train AI models with precision using advanced datasets, optimizing performance for tasks like NLP, image recognition, and automation.',
         },
         {
            icon: '/assets/svg/Virtual-Assistant.svg',
            alt: 'Virtual Assistant',
            href: '/technologies/ai-ml/virtual-assistant-development-services',
            title: 'Virtual Assistant',
            description:
               'Automate tasks, schedule meetings, and provide smart assistance with AI-powered virtual assistants for businesses and individuals.',
         },
         {
            icon: '/assets/svg/Gen-ai.svg',
            alt: 'Gen AI',
            href: '/technologies/ai-ml/generative-ai-solutions-services',
            title: 'Gen AI (Generative AI)',
            description:
               'Unlock creativity and automation with Generative AI—powering text, image, and code generation across industries.',
         },
         {
            icon: '/assets/svg/Predictive.svg',
            alt: 'Predictive Analytics & Forecasting',
            href: '/technologies/ai-ml/predictive-analytics-and-forecasting-services',
            title: 'Predictive Analytics & Forecasting',
            description:
               'Turn data into actionable insights with AI-powered predictive analytics, helping businesses forecast trends and make smarter decisions.',
         },
      ],
   },
   {
      id: 'backend',
      title: 'Backend',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/ASP-NET-icon.svg',
            alt: 'ASP.NET',
            href: '/technologies/backend/aspdotnet-development-company',
            title: 'ASP.NET',
            description:
               'Build enterprise-grade applications with ASP.NET, the framework behind scalable platforms like Stack Overflow and Microsoft services.',
         },
         {
            icon: '/assets/svg/m-Laravel-icon.svg',
            alt: 'Laravel',
            href: '/technologies/backend/laravel-application-development-company',
            title: 'Laravel',
            description:
               'Laravel simplifies PHP with an elegant syntax and built-in security—perfect for high-quality web applications.',
         },
         {
            icon: '/assets/svg/m-php-icon.svg',
            alt: 'php',
            href: '/technologies/backend/php-application-development-company',
            title: 'PHP',
            description:
               'PHP powers dynamic web apps like WordPress, Facebook, and Wikipedia, ensuring flexibility and robust backend solutions.',
         },
         {
            icon: '/assets/svg/m-ror-icon.svg',
            alt: 'Ruby on Rails (ROR)',
            href: '/technologies/backend/rubyonrail-application-development-company',
            title: 'Ruby on Rails (ROR)',
            description:
               'Used by GitHub, Shopify, and Airbnb, Rails accelerates web development with clean code and built-in efficiency.',
         },
         {
            icon: '/assets/svg/m-CodeIgniter-icon.svg',
            alt: 'CodeIgniter',
            href: '/technologies/backend/codeigniter-development-company',
            title: 'CodeIgniter',
            description:
               'Lightweight yet powerful, CodeIgniter is the go-to framework for developers who need speed and minimal configuration.',
         },
         {
            icon: '/assets/svg/m-java-icon.svg',
            alt: 'Java',
            href: '/technologies/backend/java-application-development-company',
            title: 'Java',
            description:
               'From banking systems to Android apps, Java remains the top choice for secure, high-performance, and cross-platform development.',
         },
         {
            icon: '/assets/svg/m-Node-js-icon.svg',
            alt: 'Node.js',
            href: '/technologies/backend/nodejs-application-development-company',
            title: 'Node.js',
            description:
               'Need real-time capabilities? Node.js runs event-driven apps like PayPal, Netflix, and LinkedIn at lightning speed.',
         },
         {
            icon: '/assets/svg/m-Python-icon.svg',
            alt: 'Python',
            href: '/technologies/backend/python-development-company',
            title: 'Python',
            description:
               'Want AI magic in your app? Python powers machine learning, automation, and platforms like Instagram and Spotify.',
         },
      ],
   },
   {
      id: 'blockchain',
      title: 'Blockchain',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-solidity.svg',
            alt: 'Solidity',
            href: '/technologies/blockchain/solidity-development-company',
            title: 'Solidity',
            description:
               'The backbone of smart contracts—Solidity powers Ethereum’s decentralized future, one line at a time.',
         },
         {
            icon: '/assets/svg/m-solana.svg',
            alt: 'Solana',
            href: '/technologies/blockchain/solana-development-company',
            title: 'Solana',
            description:
               'High-speed, low-cost, and scalable—Solana is redefining blockchain performance for the future of DeFi.',
         },
         {
            icon: '/assets/svg/m-web3js.svg',
            alt: 'web3.js',
            href: '/technologies/blockchain/web3js-development-company',
            title: 'Web3.js',
            description:
               'Connecting dApps to the blockchain—Web3.js bridges the gap between users and decentralized networks.',
         },
         {
            icon: '/assets/svg/m-kubernets.svg',
            alt: 'Kubernetes',
            href: '/technologies/blockchain/kubernetes-development-company',
            title: 'Kubernetes',
            description:
               'Orchestrate like a pro—Kubernetes automates scaling, deployment, and management of containerized apps.',
         },
         {
            icon: '/assets/svg/m-rust.svg',
            alt: 'Rust',
            href: '/technologies/blockchain/rust-development-company',
            title: 'Rust',
            description:
               'Blazing fast, memory-safe, and fearless—Rust is the go-to language for next-gen system programming.',
         },
         {
            icon: '/assets/svg/m-ethereum.svg',
            alt: 'Ethereum',
            href: '/technologies/blockchain/ethereum-development-company',
            title: 'Ethereum',
            description:
               'More than a blockchain—Ethereum is the foundation of the decentralized web and smart contracts.',
         },
         {
            icon: '/assets/svg/m-hardhat-seeklogo-com.svg',
            alt: 'Hardhat',
            href: '/technologies/blockchain/hardhat-development-company',
            title: 'Hardhat',
            description:
               'Smart contract development made easy—Hardhat simplifies testing, debugging, and deploying Ethereum dApps.',
         },
      ],
   },
   {
      id: 'design',
      title: 'Design & Prototype',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-Wireframing.svg',
            alt: 'Wireframing',
            href: '/technologies/design-prototype?id=wireframing',
            title: 'Wireframing',
            description:
               'Blueprints for brilliance—wireframing lays the foundation for intuitive and effective digital experiences.',
         },
         {
            icon: '/assets/svg/m-ui-development.svg',
            alt: 'User Interface (UI) Development',
            href: '/technologies/design-prototype?id=user-interface',
            title: 'User Interface (UI) Development',
            description:
               'Beautiful, responsive, and intuitive—UI development turns vision into stunning digital experiences.',
         },
         {
            icon: '/assets/svg/m-prototyping.svg',
            alt: 'Prototyping',
            href: '/technologies/design-prototype?id=prototyping',
            title: 'Prototyping',
            description:
               'Bringing concepts to life—prototyping bridges imagination and execution for flawless user interactions.',
         },
         {
            icon: '/assets/svg/m-User-Experience.svg',
            alt: 'User Experience (UX) Evaluation & Iteration',
            href: '/technologies/design-prototype?id=user-experience',
            title: 'User Experience (UX) Evaluation & Iteration',
            description:
               'Test, refine, perfect—UX iteration ensures every click feels effortless and engaging.',
         },
      ],
   },
   {
      id: 'ecommerce',
      title: 'Ecommerce',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-BigCommerce.svg',
            alt: 'BigCommerce',
            href: '/technologies/ecommerce/bigcommerce-development-company',
            title: 'BigCommerce',
            description:
               'Enterprise-grade features, without the complexity—BigCommerce helps businesses grow without limits.',
         },
         {
            icon: '/assets/svg/m-shopify.svg',
            alt: 'Shopify',
            href: '/technologies/ecommerce/shopify-development-company',
            title: 'Shopify',
            description:
               'Sell smarter, scale faster—Shopify powers millions of online stores with ease and flexibility.',
         },
         {
            icon: '/assets/svg/m-woocommerce.svg',
            alt: 'WooCommerce',
            href: '/technologies/ecommerce/woocommerce-development-company',
            title: 'WooCommerce',
            description:
               'Turn any WordPress site into a sales machine—WooCommerce makes eCommerce simple, scalable, and powerful.',
         },
         {
            icon: '/assets/svg/m-Magento.svg',
            alt: 'Magento',
            href: '/technologies/ecommerce/magento-development-company',
            title: 'Magento',
            description:
               'Built for enterprise, loved by brands—Magento delivers high-performance, customizable eCommerce experiences.',
         },
         {
            icon: '/assets/svg/m-Webflow.svg',
            alt: 'Webflow',
            href: '/technologies/ecommerce/webflow-development-company',
            title: 'Webflow',
            description:
               'No-code, all power—Webflow blends design freedom with eCommerce capabilities for stunning online stores.',
         },
      ],
   },
   {
      id: 'frontend',
      title: 'Frontend',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/Angular-icon.svg',
            alt: 'Angular',
            href: '/technologies/frontend/angular-development-company',
            title: 'Angular',
            description:
               'Angular, Google’s powerhouse framework, handles 10B+ page views daily, driving high-performance enterprise and dynamic web apps.',
         },
         {
            icon: '/assets/svg/React-icon.svg',
            alt: 'React',
            href: '/technologies/frontend/react-development-company',
            title: 'React',
            description:
               'React, used by 20M+ developers, powers 40% of top websites, enabling fast, scalable, and interactive UIs for modern web apps.',
         },
         {
            icon: '/assets/svg/vue-icon.svg',
            alt: 'Vue.js',
            href: '/technologies/frontend/vuejs-application-development-company',
            title: 'Vue.js',
            description:
               'Vue.js, the 20KB powerhouse, delivers lightning-fast UIs, combining reactivity, simplicity, and scalability for modern apps.',
         },
         {
            icon: '/assets/svg/Next-icon.svg',
            alt: 'Next.js',
            href: '/technologies/frontend/next-js-application-development-company',
            title: 'Next.js',
            description:
               'Next.js serves billions of requests monthly, making React apps faster, SEO-friendly, and production-ready by default.',
         },
         {
            icon: '/assets/svg/typescript-icon.svg',
            alt: 'TypeScript',
            href: '/technologies/frontend/typescript-development-company',
            title: 'TypeScript',
            description:
               'TypeScript eliminates 15% of JavaScript bugs before runtime, powering enterprise-scale applications with robust static typing.',
         },
      ],
   },
   {
      id: 'mobile',
      title: 'Mobile',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-Android.svg',
            alt: 'Android Apps',
            href: '/technologies/mobile/android-application-development-company',
            title: 'Android Apps',
            description:
               'Powering everything from billion-user apps to indie innovations—Android is where ideas go global.',
         },
         {
            icon: '/assets/svg/m-Flutter.svg',
            alt: 'Flutter',
            href: '/technologies/mobile/flutter-development-company',
            title: 'Flutter',
            description:
               'Beautiful, fast, and cross-platform—Flutter turns bold ideas into stunning mobile experiences effortlessly.',
         },
         {
            icon: '/assets/svg/m-iOS.svg',
            alt: 'iOS Apps',
            href: '/technologies/mobile/ios-application-development-company',
            title: 'iOS Apps',
            description:
               'Crafting premium experiences—iOS apps set the standard for design, performance, and security.',
         },
         {
            icon: '/assets/svg/m-React-Native.svg',
            alt: 'React Native',
            href: '/technologies/mobile/react-native-development-company',
            title: 'React Native',
            description:
               'One codebase, two platforms—React Native powers sleek, high-performance apps for iOS and Android effortlessly.',
         },
      ],
   },
   {
      id: 'project-management',
      title: 'Project Management',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-Big-Bouquet.svg',
            alt: 'Bitbucket',
            href: '/technologies/project-management/',
            title: 'Bitbucket',
            description:
               'Creative collaboration made easy—Bitbucket helps teams bring ideas to life.',
         },
         {
            icon: '/assets/svg/m-GitLab.svg',
            alt: 'GitLab',
            href: '/technologies/project-management/',
            title: 'GitLab',
            description:
               'From planning to deployment—GitLab offers a complete DevOps lifecycle in one platform.',
         },
         {
            icon: '/assets/svg/m-monday.svg',
            alt: 'Monday.com',
            href: '/technologies/project-management/',
            title: 'Monday.com',
            description:
               'All-in-one project management—Monday.com makes teamwork smooth, smart, and scalable.',
         },
         {
            icon: '/assets/svg/m-Trello.svg',
            alt: 'Trello',
            href: '/technologies/project-management/',
            title: 'Trello',
            description:
               'Simple, visual, and effective—Trello turns tasks into easy-to-manage boards.',
         },
         {
            icon: '/assets/svg/m-rust.svg', // This icon seems incorrect for ClickUp
            alt: 'ClickUp',
            href: '/technologies/project-management/',
            title: 'ClickUp',
            description:
               'One app to replace them all—ClickUp is the ultimate tool for productivity and project management.',
         },
         {
            icon: '/assets/svg/m-microsoft-teams.svg',
            alt: 'Microsoft Teams',
            href: '/technologies/project-management/',
            title: 'Microsoft Teams',
            description:
               'Chat, call, and collaborate—MS Teams keeps your team connected and workflows streamlined',
         },
         {
            icon: '/assets/svg/m-Slack.svg',
            alt: 'Slack',
            href: '/technologies/project-management/',
            title: 'Slack',
            description:
               'Where work happens—Slack keeps teams connected, organized, and productive in real time.',
         },
      ],
   },
   {
      id: 'testing',
      title: 'QA & Testing',
      icon: '/assets/svg/two-right-icon.svg',
      submenu: [
         {
            icon: '/assets/svg/m-Automated-Testing.svg',
            alt: 'Automated Testing',
            href: '/technologies/qa-testing/automated-testing-services',
            title: 'Automated Testing',
            description:
               'Speed, accuracy, and efficiency—automated testing keeps your software bug-free at scale.',
         },
         {
            icon: '/assets/svg/m-Manual-Testing.svg',
            alt: 'Manual Testing',
            href: '/technologies/qa-testing/manual-testing-services',
            title: 'Manual Testing',
            description:
               'When precision matters, human insight catches what automation might miss—manual testing ensures real-world reliability.',
         },
         {
            icon: '/assets/svg/m-vapt.svg',
            alt: 'Vulnerability Assessment & Penetration Testing',
            href: '/technologies/qa-testing/vulnerability-assessment-penetration-testing',
            title: 'Vulnerability Assessment & Penetration Testing',
            description:
               'Think like a hacker, act like a shield—VAPT fortifies your system against cyber threats.',
         },
         {
            icon: '/assets/svg/m-Compatibility-Testing.svg',
            alt: 'Compatibility Testing',
            href: '/technologies/qa-testing/compatibility-testing-services',
            title: 'Compatibility Testing',
            description:
               'One app, multiple environments—compatibility testing ensures smooth performance across all devices and platforms.',
         },
         {
            icon: '/assets/svg/m-Performance-Testing.svg',
            alt: 'Performance Testing',
            href: '/technologies/qa-testing/performance-testing-services',
            title: 'Performance Testing',
            description:
               'Push your app to the limits—performance testing ensures speed, stability, and seamless user experience.',
         },
      ],
   },
]

const servicesData = [
   {
      columnClass: 'col-12 col-lg-3 col-xl-3 mega-menu-column',
      links: [
         {
            href: '/services/ai-ml-development-company',
            text: 'AI & ML Development',
         },
         {
            href: '/services/eommerce-development-company',
            text: 'Ecommerce Development',
         },
         {
            href: '/services/web-application-development-company',
            text: 'Web Application Development',
         },
      ],
   },
   {
      columnClass: 'col-12 col-lg-3 col-xl-3 mega-menu-column',
      links: [
         {
            href: '/services/custom-software-development-company',
            text: 'Custom Software Development',
         },
         {
            href: '/services/progressive-web-app-development-company',
            text: 'Progressive Web App Development',
         },
         {
            href: '/services/mobile-application-development-company',
            text: 'Mobile App Development',
         },
      ],
   },
   {
      columnClass: 'col-12 col-lg-2 col-xl-2 last-div mega-menu-column',
      links: [
         {
            href: '/services/blockchain-development-company',
            text: 'Blockchain Development',
         },
         {
            href: '/services/testing-qa-services-company',
            text: 'Testing and QA Services',
         },
         {
            href: '/services/web-design-services-company',
            text: 'Web design Services',
         },
      ],
   },
]

const certificationsData = [
   { src: '/assets/svg/ios-2015.svg', alt: 'ISO Certification' },
   { src: '/assets/svg/ios-2013.svg', alt: 'iso Certification' },
   { src: '/assets/svg/clutch.svg', alt: 'clutch' },
   { src: '/assets/svg/upwork.svg', alt: 'upwork' },
]

const industriesData = [
   {
      className: 'col-12 col-lg-3 col-xl-3 mega-menu-column',
      links: [
         {
            title: 'Fintech',
            href: '/industries/fintech-software-development-solutions',
         },
         {
            title: 'Ecommerce',
            href: '/industries/e-commerce-software-development-solutions',
         },
         {
            title: 'Travel & Tourism',
            href: '/industries/travel-tourism-software-development-solutions',
         },
         {
            title: 'Restaurants & Hospitality',
            href: '/industries/restaurant-hospitality-software-solutions',
         },
      ],
   },
   {
      className: 'col-12 col-lg-3 col-xl-3 mega-menu-column',
      links: [
         {
            title: 'Education',
            href: '/industries/education-software-development-solutions',
         },
         {
            title: 'Real Estate',
            href: '/industries/real-estate-software-development-solutions',
         },
         {
            title: 'Health and Fitness',
            href: '/industries/health-fitness-software-development-solutions',
         },
         {
            title: 'Supply chain and logistics',
            href: '/industries/supply-chain-logistics-software-solutions',
         },
      ],
   },
   {
      className: 'col-12 col-lg-2 col-xl-2 last-div mega-menu-column',
      links: [
         {
            title: 'Gaming & Sports',
            href: '/industries/gaming-sports-software-development-solutions',
         },
         {
            title: 'Social and dating',
            href: '/industries/social-dating-software-development-solutions',
         },
         {
            title: 'Media & Entertainment',
            href: '/industries/media-entertainment-software-solutions',
         },
         {
            title: 'Government & Public Sector',
            href: '/industries/government-public-sector-software-solutions',
         },
      ],
   },
]

export default function Navbar() {
   const [activeIndex, setActiveIndex] = useState(null)
   const pathname = usePathname()
   const [isMenuOpen, setIsMenuOpen] = useState(false)
   // const [isHomePage, setIsHomePage] = useState(false)
   const isHomePage = pathname === '/'
   const isIndustriesPage =
      pathname.includes('industries') && pathname !== '/industries'
   const headerOverlayRef = useRef(null)
   const [activeMenu, setActiveMenu] = useState('')
   const [hoveredMenu, setHoveredMenu] = useState(null)

   const getActiveMenu = () => {
      if (pathname.includes('/services')) return 'services'
      if (pathname.includes('/technologies')) return 'technologies'
      if (pathname.includes('/industries')) return 'industries'
      if (pathname.includes('/portfolio')) return 'portfolio'
      if (pathname.includes('/news-room')) return 'news-room'
      if (pathname.includes('/discover-benzatine')) return 'discover-benzatine'
      return ''
   }
   const handleMenuHover = (menuName) => {
      if (window.innerWidth >= 1200) {
         // Desktop breakpoint
         setHoveredMenu(menuName)
      }
   }

   const handleMenuClicked = () => {
      setHoveredMenu(null)
   }

   useEffect(() => {
      setActiveMenu(getActiveMenu())

      return () => {}
   }, [pathname])

   // useEffect(() => {
   //    const selectedButton = document.querySelector(
   //       'button.nav-links[aria-selected="true"][data-bs-target="#backend"]'
   //    )

   //    if (selectedButton) {
   //       const style = document.createElement('style')
   //       style.textContent = `
   //    .certifications::before {
   //      content: '';
   //      display: block;
   //      margin: 10px 0 !important;
   //    }
   //  `
   //       document.head.appendChild(style)

   //       return () => {
   //          document.head.removeChild(style)
   //       }
   //    }
   // }, [])

   const handleMenuClick = (index) => {
      setActiveIndex((prevIndex) => (prevIndex === index ? null : index))
   }
   const toggleMenu = () => {
      const navbar = document.querySelector('.navbar')
      if (navbar && isHomePage) {
         navbar.classList.toggle('home-nav-click')
      }
      setIsMenuOpen(!isMenuOpen)
   }
   const onClickMenu = () => {
      setIsMenuOpen(false)
   }

   useEffect(() => {
      onClickMenu()

      return () => {}
   }, [pathname])

   useEffect(() => {
      import('bootstrap/dist/js/bootstrap.bundle.min.js')
   }, [])

   const openCalendly = () => {
      if (typeof window !== 'undefined' && window.Calendly) {
         window.Calendly.initPopupWidget({
            url: 'https://calendly.com/brijesh-vadukia/let-s-schedule-a-meeting',
         })
      } else {
         console.error('Calendly script not loaded yet.')
      }
   }

   const showOverlay = useCallback(() => {
      if (headerOverlayRef.current) {
         headerOverlayRef.current.style.display = 'block'
      }
   }, [])

   const hideOverlay = useCallback(() => {
      if (headerOverlayRef.current) {
         headerOverlayRef.current.style.display = 'none'
      }
   }, [])

   //
   useEffect(() => {
      const handleNavInteractions = () => {
         const navLinks = document.querySelectorAll('.desktop-nav-link')
         const dropdownMenus = document.querySelectorAll('.dropdown-menu')

         const handleLinkMouseEnter = () => showOverlay()

         const handleMenuMouseLeave = (e) => {
            if (!e.relatedTarget?.closest('.nav-item')) {
               hideOverlay()
            }
         }

         const handleNavItemMouseLeave = (e) => {
            if (
               !e.relatedTarget?.closest('.dropdown-menu') 
               // &&
               // !e.relatedTarget?.closest('.nav-item')
            ) {
               hideOverlay()
            }
         }

         // Setup event listeners
         navLinks.forEach((link) => {
            const parentNavItem = link.closest('.nav-item')
            const dropdownMenu = parentNavItem?.querySelector('.dropdown-menu')

            link.addEventListener('mouseenter', handleLinkMouseEnter)
            // link.addEventListener('click', handleLinkClick)

            if (dropdownMenu) {
               dropdownMenu.addEventListener('mouseenter', showOverlay)
               dropdownMenu.addEventListener('mouseleave', handleMenuMouseLeave)
            }

            parentNavItem?.addEventListener(
               'mouseleave',
               handleNavItemMouseLeave
            )
         })

         // Document level handlers
         const handleDocumentClick = (e) => {
            if (
               !e.target.closest('.dropdown-menu') &&
               !e.target.hasAttribute('data-bs-toggle')
            ) {
               hideOverlay()
            }
         }

         document.addEventListener('click', handleDocumentClick)
         document.addEventListener('hidden.bs.dropdown', hideOverlay)

         // Cleanup function
         return () => {
            navLinks.forEach((link) => {
               const parentNavItem = link.closest('.nav-item')
               const dropdownMenu =
                  parentNavItem?.querySelector('.dropdown-menu')

               link.removeEventListener('mouseenter', handleLinkMouseEnter)
               // link.removeEventListener('click', handleLinkClick)

               if (dropdownMenu) {
                  dropdownMenu.removeEventListener('mouseenter', showOverlay)
                  dropdownMenu.removeEventListener(
                     'mouseleave',
                     handleMenuMouseLeave
                  )
               }

               parentNavItem?.removeEventListener(
                  'mouseleave',
                  handleNavItemMouseLeave
               )
            })

            document.removeEventListener('click', handleDocumentClick)
            document.removeEventListener('hidden.bs.dropdown', hideOverlay)
         }
      }

      return handleNavInteractions()
   }, [showOverlay, hideOverlay])

   //
   useEffect(() => {
      // Only run this effect on the home page
      if (isHomePage) {
         const handleScroll = () => {
            const navbar = document.querySelector('.navbar')
            if (navbar) {
               if (window.scrollY > 100) {
                  navbar.classList.add('scrolled')
                  navbar.classList.remove('home-nav')
               } else {
                  navbar.classList.remove('scrolled')
                  navbar.classList.add('home-nav')
               }
            }
         }

         // Add scroll event listener
         window.addEventListener('scroll', handleScroll)

         // Initialize navbar class on mount
         const navbar = document.querySelector('.navbar')
         if (navbar) {
            navbar.classList.add('home-nav')
         }

         // Cleanup function
         return () => {
            window.removeEventListener('scroll', handleScroll)
         }
      }
   }, [isHomePage])

   return (
      <>
         <div
            ref={headerOverlayRef}
            className="header__overlay"
            style={{ display: 'none' }}
         ></div>
         <nav
            className={`${
               isHomePage
                  ? 'home-nav'
                  : isIndustriesPage
                  ? 'industries-nav'
                  : ''
            }  navbar navbar-expand-xl`}
         >
            <Script
               src="https://assets.calendly.com/assets/external/widget.js"
               strategy="lazyOnload"
            />
            <link
               rel="stylesheet"
               href="https://assets.calendly.com/assets/external/widget.css"
            />
            <link
               rel="stylesheet"
               href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
            />
            <div className="container-fluid">
               <Link className="navbar-brand" href="/">
                  {/* <!-- <img src="/assets/image/logo.png" alt="Logo" height="40" /> -- */}
                  <LogoIcon />
               </Link>

               <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleMenu}
                  aria-expanded={isMenuOpen}
                  aria-label="Toggle navigation"
               >
                  <span className="navbar-toggler-icon"></span>
               </button>

               <div
                  className={`collapse navbar-collapse benz-nav-item ${
                     isMenuOpen ? 'show' : ''
                  }`}
                  id="navbarNav"
               >
                  <ul className="navbar-nav desktop-nav">
                     <li className="nav-item">
                        <Link
                           className={`nav-link desktop-nav-link ${
                              activeMenu === 'services' ? 'active' : ''
                           }`}
                           href="/services"
                           onMouseEnter={() => handleMenuHover('services')}
                           onClick={handleMenuClicked}
                        >
                           Services
                        </Link>
                        <div
                           className={`dropdown-menu ${
                              hoveredMenu === 'services' ? 'show-menu' : ''
                           }`}
                           onMouseEnter={() => handleMenuHover('services')}
                           onMouseLeave={() => setHoveredMenu(null)}
                        >
                           <div className="dropdown-list">
                              <div className="row align-items-center">
                                 {servicesData.map((column, columnIndex) => (
                                    <div
                                       key={columnIndex}
                                       className={column.columnClass}
                                    >
                                       <ul>
                                          {column.links.map(
                                             (link, linkIndex) => (
                                                <li
                                                   key={linkIndex}
                                                   onClick={handleMenuClicked}
                                                >
                                                   <Link href={link.href}>
                                                      {link.text}
                                                   </Link>
                                                </li>
                                             )
                                          )}
                                       </ul>
                                    </div>
                                 ))}
                                 <div className="col-12 col-lg-4">
                                    <div className="menu-box servies-box">
                                       <p>
                                          Schedule a free discovery session to
                                          explore your needs and find tailored
                                          solutions with no obligation.
                                       </p>
                                       <h3>
                                          High-quality, Cost-effective IT
                                          Outsourcing
                                       </h3>
                                       <Link
                                          href="/services"
                                          className="bez-outline-btn explrer-all-servies d-flex align-items-center gap-3"
                                          onClick={handleMenuClicked}
                                       >
                                          <span>Explorer all services</span>
                                          <NavRightArrow />
                                       </Link>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="nav-item">
                        <Link
                           className={`nav-link desktop-nav-link ${
                              activeMenu === 'technologies' ? 'active' : ''
                           }`}
                           href="/technologies"
                           onMouseEnter={() => handleMenuHover('technologies')}
                           onClick={handleMenuClicked}
                        >
                           Technologies
                        </Link>
                        <div
                           className={`dropdown-menu teq-menu-section ${
                              hoveredMenu === 'technologies' ? 'show-menu' : ''
                           }`}
                           // onMouseEnter={() => handleMenuHover('technologies')}
                           onMouseLeave={() => setHoveredMenu(null)}
                        >
                           <div className="dropdown-list">
                              <div className="row">
                                 <div className="col-md-3 teq-menu-list">
                                    <ul
                                       className="nav nav-pills flex-column"
                                       id="tabs-menu"
                                       role="tablist"
                                    >
                                       {technologiesData.map((tech, index) => (
                                          <li
                                             className="nav-items"
                                             key={tech.id}
                                          >
                                             <button
                                                className={`nav-links d-flex align-items-center justify-content-between ${
                                                   index === 0 ? 'active' : ''
                                                }`}
                                                data-bs-toggle="pill"
                                                data-bs-target={`#${tech.id}`}
                                                type="button"
                                             >
                                                {tech.title}
                                                <img
                                                   className="show-teq-icon"
                                                   src={tech.icon}
                                                   alt=""
                                                />
                                             </button>
                                          </li>
                                       ))}
                                    </ul>
                                 </div>
                                 <div className="col-md-9">
                                    <div
                                       className="tab-content"
                                       id="tabs-content"
                                    >
                                       {technologiesData.map((tech, index) => (
                                          <div
                                             className={`tab-pane fade ${
                                                index === 0 ? 'show active' : ''
                                             } ${
                                                tech.id === 'ai-ml' ||
                                                tech.id === 'frontend'
                                                   ? 'menu-show-bottom-boder'
                                                   : ''
                                             }`}
                                             id={tech.id}
                                             key={tech.id}
                                          >
                                             <div className="row">
                                                {/* Render sub-menu items - Split into two columns if needed */}
                                                <div className="col-md-6 add-boder-right">
                                                   {tech.submenu
                                                      .slice(
                                                         0,
                                                         Math.ceil(
                                                            tech.submenu
                                                               .length / 2
                                                         )
                                                      )
                                                      .map((sub, subIndex) => (
                                                         <div
                                                            className={`teq-sub-menu-list ${
                                                               subIndex > 0
                                                                  ? 'mt-4'
                                                                  : ''
                                                            }`}
                                                            key={`${tech.id}-${subIndex}`}
                                                         >
                                                            <div className="d-flex align-items-center gap-3 justify-content-start">
                                                               <img
                                                                  src={sub.icon}
                                                                  alt={sub.alt}
                                                               />
                                                               <Link
                                                                  href={
                                                                     sub.href
                                                                  }
                                                                  className="teq-title"
                                                                  onClick={
                                                                     handleMenuClicked
                                                                  }
                                                               >
                                                                  {sub.title}
                                                               </Link>
                                                            </div>
                                                            <div className="teq-desc">
                                                               {sub.description}
                                                            </div>
                                                         </div>
                                                      ))}
                                                </div>
                                                <div className="col-md-6">
                                                   {tech.submenu
                                                      .slice(
                                                         Math.ceil(
                                                            tech.submenu
                                                               .length / 2
                                                         )
                                                      )
                                                      .map((sub, subIndex) => (
                                                         <div
                                                            className={`teq-sub-menu-list ${
                                                               subIndex > 0
                                                                  ? 'mt-4'
                                                                  : ''
                                                            }`}
                                                            key={`${tech.id}-${
                                                               subIndex +
                                                               Math.ceil(
                                                                  tech.submenu
                                                                     .length / 2
                                                               )
                                                            }`}
                                                         >
                                                            <div className="d-flex align-items-center gap-3 justify-content-start">
                                                               <img
                                                                  src={sub.icon}
                                                                  alt={sub.alt}
                                                               />
                                                               <Link
                                                                  href={
                                                                     sub.href
                                                                  }
                                                                  onClick={
                                                                     handleMenuClicked
                                                                  }
                                                                  className="teq-title"
                                                               >
                                                                  {sub.title}
                                                               </Link>
                                                            </div>
                                                            <div className="teq-desc">
                                                               {sub.description}
                                                            </div>
                                                         </div>
                                                      ))}
                                                </div>
                                             </div>
                                          </div>
                                       ))}

                                       {/* <!-- Certifications & Reviews --> */}
                                       <div className="certifications d-flex align-items-center gap-3 flex-wrap">
                                          <div className="d-flex align-items-center gap-4 flex-wrap">
                                             {certificationsData.map(
                                                (cert, index) => (
                                                   <img
                                                      src={cert.src}
                                                      alt={cert.alt}
                                                      key={`cert-${index}`}
                                                   />
                                                )
                                             )}
                                          </div>
                                          <div className="let-contact-section">
                                             <div>
                                                <span>
                                                   Speak with an expert
                                                </span>
                                                <p>
                                                   we had love to resolve your
                                                   queries
                                                </p>
                                             </div>
                                             <div className="let-btn">
                                                <Link
                                                   href="/discover-benzatine/contact-us"
                                                   className=""
                                                   onClick={handleMenuClicked}
                                                >
                                                   <button>Let's Talk</button>
                                                </Link>
                                             </div>
                                          </div>
                                       </div>
                                       {/* <!-- Contact Section --> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="nav-item">
                        <Link
                           className={`nav-link desktop-nav-link ${
                              activeMenu === 'industries' ? 'active' : ''
                           }`}
                           href="/industries"
                           onMouseEnter={() => handleMenuHover('industries')}
                           onClick={handleMenuClicked}
                        >
                           Industries
                        </Link>
                        <div
                           className={`dropdown-menu ${
                              hoveredMenu === 'industries' ? 'show-menu' : ''
                           }`}
                           onMouseLeave={() => setHoveredMenu(null)}
                        >
                           <div className="dropdown-list">
                              <div className="row align-items-center">
                                 {industriesData.map((column, index) => (
                                    <div
                                       key={index}
                                       className={column.className}
                                    >
                                       <ul>
                                          {column.links.map((link) => (
                                             <li key={link.href}>
                                                <Link
                                                   href={link.href}
                                                   onClick={handleMenuClicked}
                                                >
                                                   {link.title}
                                                </Link>
                                             </li>
                                          ))}
                                       </ul>
                                    </div>
                                 ))}
                                 <div className="col-12 col-lg-4">
                                    <div className="menu-box">
                                       <p>Speak with an expert</p>
                                       <h3>let’s grow together!</h3>
                                       <Link
                                          href="/discover-benzatine/contact-us"
                                          className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                                          onClick={handleMenuClicked}
                                       >
                                          <span>get quote</span>
                                          <NavRightArrow />
                                       </Link>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="nav-item">
                        <Link
                           className={`nav-link desktop-nav-link ${
                              activeMenu === 'portfolio' ? 'active' : ''
                           }`}
                           href="/portfolio"
                           onMouseEnter={() => handleMenuHover('portfolio')}
                           onClick={handleMenuClicked}
                        >
                           Portfolio
                        </Link>
                        <div
                           className={`dropdown-menu ${
                              hoveredMenu === 'portfolio' ? 'show-menu' : ''
                           }`}
                           onMouseLeave={() => setHoveredMenu(null)}
                        >
                           <div className="dropdown-list">
                              <div className="d-flex align-items-center justify-content-center portfoli-menu gap-4 flex-wrap">
                                 <div className="protfoli-menu-wrap">
                                    <div className="menu-box menu-portfoli-box">
                                       <p>Explore Our Work</p>
                                       <h3>portfolios</h3>
                                       <Link
                                          href="/portfolio/"
                                          className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                                          onClick={handleMenuClicked}
                                       >
                                          <span>see portfolio</span>
                                          <NavRightArrow />
                                       </Link>
                                    </div>
                                 </div>
                                 <div className="protfoli-menu-wrap">
                                    <div className="menu-box menu-portfoli-box">
                                       <p>Explore Our case study</p>
                                       <h3>case study</h3>
                                       <Link
                                          href="/portfolio/case-studies/"
                                          className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                                          onClick={handleMenuClicked}
                                       >
                                          <span>see case study</span>
                                          <NavRightArrow />
                                       </Link>
                                    </div>
                                 </div>

                                 <div className="protfoli-menu-wrap">
                                    <div className="menu-box follow-us-div">
                                       <h3>follow us on</h3>
                                       <div className="d-flex align-items-center justify-content-start gap-3 mt-4 follow_us_on">
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://www.behance.net/benzatine-infotech"
                                             target="_blank"
                                          >
                                             <img src="/assets/svg/behance.svg" />
                                             <span className="follow-us-name">
                                                behance
                                             </span>
                                          </a>
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://dribbble.com/chirag_vadukia"
                                             target="_blank"
                                          >
                                             <img src="/assets/svg/dribble.svg" />
                                             <span className="follow-us-name">
                                                dribble
                                             </span>
                                          </a>
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://github.com/bpvadukia"
                                             target="_blank"
                                          >
                                             <img src="/assets/svg/Github.svg" />
                                             <span className="follow-us-name">
                                                Github
                                             </span>
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="nav-item">
                        <Link
                           className={`nav-link ${
                              activeMenu === 'news-room' ? 'active' : ''
                           }`}
                           href="/news-room"
                           data-active-nav="news-room"
                           onMouseEnter={() => handleMenuHover('news-room')}
                           onMouseLeave={() => setHoveredMenu(null)}
                        >
                           News Room
                        </Link>
                     </li>
                     <li className="nav-item">
                        <Link
                           className={`nav-link desktop-nav-link ${
                              activeMenu === 'discover-benzatine'
                                 ? 'active'
                                 : ''
                           }`}
                           href="#"
                           onMouseEnter={() =>
                              handleMenuHover('discover-benzatine')
                           }
                        >
                           discover benzatine
                        </Link>
                        <div
                           className={`dropdown-menu ${
                              hoveredMenu === 'discover-benzatine'
                                 ? 'show-menu'
                                 : ''
                           }`}
                        >
                           <div className="dropdown-list">
                              <div className="row align-items-center justify-content-center">
                                 <div className="col-12 col-lg-3 col-xl-3 mega-menu-column">
                                    <ul>
                                       <li>
                                          <Link
                                             href="/discover-benzatine/about-us"
                                             onClick={handleMenuClicked}
                                          >
                                             About Us
                                          </Link>
                                       </li>
                                       <li>
                                          <Link
                                             href="/discover-benzatine/our-work-process"
                                             onClick={handleMenuClicked}
                                          >
                                             Our Work Process
                                          </Link>
                                       </li>
                                       <li>
                                          <Link
                                             href="/discover-benzatine/our-culture"
                                             onClick={handleMenuClicked}
                                          >
                                             Our Culture
                                          </Link>
                                       </li>
                                    </ul>
                                 </div>
                                 <div className="col-12 col-lg-3 col-xl-3 mega-menu-column">
                                    <ul>
                                       <li>
                                          <Link
                                             href="/discover-benzatine/contact-us"
                                             onClick={handleMenuClicked}
                                          >
                                             Contact Us
                                          </Link>
                                       </li>
                                       <li>
                                          <Link
                                             href="/discover-benzatine/career-overview"
                                             onClick={handleMenuClicked}
                                          >
                                             Career Overview
                                          </Link>
                                       </li>
                                    </ul>
                                 </div>

                                 <div className="col-12 col-lg-4">
                                    <div className="menu-box follow-us-div">
                                       <h3>follow us on</h3>
                                       <div className="d-flex align-items-center justify-content-start gap-3 mt-4 follow_us_on">
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://www.behance.net/benzatine-infotech"
                                             target="_blank"
                                             onClick={handleMenuClicked}
                                          >
                                             <img src="/assets/svg/behance.svg" />
                                             <span className="follow-us-name">
                                                behance
                                             </span>
                                          </a>
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://dribbble.com/chirag_vadukia"
                                             target="_blank"
                                             onClick={handleMenuClicked}
                                          >
                                             <img src="/assets/svg/dribble.svg" />
                                             <span className="follow-us-name">
                                                dribble
                                             </span>
                                          </a>
                                          <a
                                             className="d-flex align-items-center justify-content-center gap-3 flex-column"
                                             href="https://github.com/bpvadukia"
                                             target="_blank"
                                             onClick={handleMenuClicked}
                                          >
                                             <img src="/assets/svg/Github.svg" />
                                             <span className="follow-us-name">
                                                Github
                                             </span>
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                  </ul>

                  {/* <!-- Mobile nav --> */}
                  <MobileNav
                     onClickMenu={onClickMenu}
                     handleMenuClick={handleMenuClick}
                     activeIndex={activeIndex}
                  />
                  <div className="scheduled-btn-section">
                     <button className="scheduled-btn" onClick={openCalendly}>
                        Scheduled a Meeting
                     </button>
                  </div>
               </div>
            </div>
         </nav>
      </>
   )
}

const MobileNav = ({ onClickMenu, handleMenuClick, activeIndex }) => {
   return (
      <ul className="navbar-nav mobile-nav">
         {/* <!-- <li className="">
             <a className="nav-link" href="#home">Home</a>
         </li> --> */}
         <li
            className={`nav-li ${activeIndex === 1 ? 'nav-mobile-active' : ''}`}
         >
            <div className="mobile-nav-item">
               <Link
                  href="/services/"
                  onClick={onClickMenu}
                  className="header__nav-link"
               >
                  Services
               </Link>
               <button
                  className="header__menu-buttn"
                  onClick={() => handleMenuClick(1)}
               >
                  <span
                     className="cu-up-down-arrow"
                     style={{
                        transform:
                           activeIndex === 1
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                     }}
                  >
                     <DownArrow />
                  </span>
               </button>
            </div>
            <div
               className="header__nav-inner"
               style={{
                  display: activeIndex === 1 ? 'block' : 'none',
               }}
            >
               <div className="row">
                  <div className="col-12 col-md-6">
                     <div className="header__col">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/services/ai-ml-development-company"
                                    className="nav-link header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       AI & ML Development
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/eommerce-development-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Ecommerce Development
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/web-application-development-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Web Application Development
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/custom-software-development-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Custom Software Development
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/progressive-web-app-development-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Progressive Web App Development
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-12 col-md-6">
                     <div className="header__col add-border-left">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/services/blockchain-development-company"
                                    className="nav-link header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Blockchain Development
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/testing-qa-services-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Testing and QA Services
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/web-design-services-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Web design Services
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/services/mobile-application-development-company"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Mobile App Development
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="menu-box servies-box mobile-servies-box">
                     <p>
                        Schedule a free discovery session to explore your needs
                        and find tailored solutions with no obligation.
                     </p>
                     <h3>High-quality, Cost-effective IT Outsourcing</h3>
                     <a
                        href="/services/"
                        className="bez-outline-btn explrer-all-servies d-flex align-items-center gap-3"
                     >
                        <span>Explorer all services</span>
                        <NavRightArrow />
                     </a>
                  </div>
               </div>
            </div>
         </li>
         <li
            className={`nav-li teq-mobile-menu ${
               activeIndex === 2 ? 'nav-mobile-active' : ''
            }`}
         >
            <div className="mobile-nav-item">
               <Link href="/technologies" className="header__nav-link">
                  Technologies
               </Link>
               <button
                  className="header__menu-buttn"
                  onClick={() => handleMenuClick(2)}
               >
                  <span
                     className="cu-up-down-arrow"
                     style={{
                        transform:
                           activeIndex === 2
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                     }}
                  >
                     <DownArrow />
                  </span>
               </button>
            </div>
            <div
               className="header__nav-inner"
               style={{
                  display: activeIndex === 2 ? 'block' : 'none',
               }}
            >
               <div className="row">
                  {technologiesData.map((section, sectionIndex) => (
                     <div
                        className="col-12 col-md-6"
                        key={`tech-section-${sectionIndex}`}
                     >
                        <div
                           className={`header__col ${
                              sectionIndex % 2 !== 0 ? 'add-border-left' : ''
                           }`}
                        >
                           <div className="header__col-title bg-pink">
                              <div className="header__col-icon">
                                 {/* If you have different icons, you would render them dynamically here */}
                                 <i className="icon icon-edgesensor-low"></i>
                              </div>
                              <div className="header__col-text">
                                 {section.title}
                              </div>
                           </div>
                           <div className="border-div">
                              <ul className="list-unstyled">
                                 {section.submenu.map((link, linkIndex) => (
                                    <li
                                       key={`tech-link-${sectionIndex}-${linkIndex}`}
                                    >
                                       <Link
                                          href={link.href}
                                          className="nav-link header__col-link"
                                       >
                                          <span className="header__col-link-text">
                                             {link.title}{' '}
                                             {/* Using link.title as text */}
                                          </span>
                                       </Link>
                                    </li>
                                 ))}
                              </ul>
                           </div>
                        </div>
                     </div>
                  ))}

                  {/* <!--  --> */}
                  <div className="certifications d-flex align-items-center gap-3 flex-wrap">
                     <div className="d-flex align-items-center gap-4 flex-wrap">
                        <img
                           src="/assets/svg/ios-2015.svg"
                           alt="ISO Certification"
                        />
                        <img
                           src="/assets/svg/ios-2013.svg"
                           alt="iso Certification"
                        />
                        <img src="/assets/svg/clutch.svg" alt="clutch" />
                        <img src="/assets/svg/upwork.svg" alt="upwork" />
                     </div>
                     <div className="let-contact-section">
                        <div>
                           <span>Speak with an expert</span>
                           <p>we had love to resolve your queries</p>
                        </div>
                        <div className="let-btn">
                           <Link href="/discover-benzatine/contact-us">
                              <button>Let's Talk</button>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </li>
         <li
            className={`nav-li ${activeIndex === 3 ? 'nav-mobile-active' : ''}`}
         >
            <div className="mobile-nav-item">
               <Link href="/industries" className="header__nav-link">
                  Industries
               </Link>
               <button
                  className="header__menu-buttn"
                  onClick={() => handleMenuClick(3)}
               >
                  <span
                     className="cu-up-down-arrow"
                     style={{
                        transform:
                           activeIndex === 3
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                     }}
                  >
                     <DownArrow />
                  </span>
               </button>
            </div>
            <div
               className="header__nav-inner"
               style={{
                  display: activeIndex === 3 ? 'block' : 'none',
               }}
            >
               <div className="row">
                  <div className="col-12 col-md-6">
                     <div className="header__col">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/industries/fintech-software-development-solutions"
                                    className="nav-link header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Fintech
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/e-commerce-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Ecommerce
                                    </span>
                                 </Link>
                              </li>
                              {/* <!-- <li>
                                         <a
                                             href="/services/web-application-development-company.html"
                                             className="header__col-link"
                                         >
                                             <span
                                                 className="header__col-link-text"
                                                 >Web Application
                                                 Development</span
                                             >
                                         </a>
                                     </li> --> */}
                              <li>
                                 <Link
                                    href="/industries/travel-tourism-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Travel & Tourism
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/restaurant-hospitality-software-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Restaurants & Hospitality
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/education-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Education
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/real-estate-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Real Estate
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-12 col-md-6">
                     <div className="header__col add-border-left">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/industries/health-fitness-software-development-solutions"
                                    className="nav-link header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Health and Fitness
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/supply-chain-logistics-software-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Supply chain and logistics
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/gaming-sports-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Gaming & Sports
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/social-dating-software-development-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Social and dating
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/media-entertainment-software-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Media & Entertainment
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/industries/government-public-sector-software-solutions"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Government & Public Sector
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>

                  <div className="menu-box mobile-servies-box">
                     <p>Speak with an expert</p>
                     <h3>let’s grow together!</h3>
                     <Link
                        href="/discover-benzatine/contact-us"
                        className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                     >
                        <span>get quote</span>
                        <NavRightArrow />
                     </Link>
                  </div>
               </div>
            </div>
         </li>
         <li
            className={`nav-li ${activeIndex === 4 ? 'nav-mobile-active' : ''}`}
         >
            <div className="mobile-nav-item">
               <Link href="/portfolio/" className="header__nav-link">
                  Portfolio
               </Link>
               <button
                  className="header__menu-buttn"
                  onClick={() => handleMenuClick(4)}
               >
                  <span
                     className="cu-up-down-arrow"
                     style={{
                        transform:
                           activeIndex === 4
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                     }}
                  >
                     <DownArrow />
                  </span>
               </button>
            </div>
            <div
               className="header__nav-inner"
               style={{
                  display: activeIndex === 4 ? 'block' : 'none',
               }}
            >
               <div className="mt-3">
                  <div className="d-flex align-items-center justify-content-center portfoli-menu flex-wrap">
                     <div className="protfoli-menu-wrap add-menu-border">
                        <div className="menu-box menu-portfoli-box">
                           <p>Explore Our Work</p>
                           <h3>portfolio</h3>
                           <Link
                              href="/portfolio/"
                              className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                           >
                              <span>see portfolio</span>
                              <NavRightArrow />
                           </Link>
                        </div>
                     </div>
                     <div className="protfoli-menu-wrap add-menu-border">
                        <div className="menu-box menu-portfoli-box">
                           <p>Explore Our case study</p>
                           <h3>case study</h3>
                           <Link
                              href="/portfolio/case-studies/"
                              className="bez-outline-btn d-flex align-items-center gap-3 menu-more-btn"
                           >
                              <span>see case study</span>
                              <NavRightArrow />
                           </Link>
                        </div>
                     </div>

                     <div className="protfoli-menu-wrap add-menu-border">
                        <div className="menu-box follow-us-div">
                           <h3>follow us on</h3>
                           <div className="d-flex align-items-center justify-content-start gap-3 mt-4 flex-wrap">
                              <a
                                 className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                                 href="https://www.behance.net/benzatine-infotech"
                                 target="_blank"
                              >
                                 <img src="/assets/svg/behance.svg" />
                                 <span className="follow-us-name">behance</span>
                              </a>
                              <a
                                 className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                                 href="https://dribbble.com/chirag_vadukia"
                                 target="_blank"
                              >
                                 <img src="/assets/svg/dribble.svg" />
                                 <span className="follow-us-name">dribble</span>
                              </a>
                              <a
                                 className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                                 href="https://github.com/bpvadukia"
                                 target="_blank"
                              >
                                 <img src="/assets/svg/Github.svg" />
                                 <span className="follow-us-name">Github</span>
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </li>

         <li
            className={`nav-li ${activeIndex === 5 ? 'nav-mobile-active' : ''}`}
         >
            <div className="mobile-nav-item">
               <div className="header__nav-link">Discover Benzatine</div>
               <button
                  className="header__menu-buttn"
                  onClick={() => handleMenuClick(5)}
               >
                  <span
                     className="cu-up-down-arrow"
                     style={{
                        transform:
                           activeIndex === 5
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                     }}
                  >
                     <DownArrow />
                  </span>
               </button>
            </div>
            <div
               className="header__nav-inner"
               style={{
                  display: activeIndex === 5 ? 'block' : 'none',
               }}
            >
               <div className="row">
                  <div className="col-12 col-md-6">
                     <div className="header__col">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/discover-benzatine/about-us"
                                    className="nav-link header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       About Us
                                    </span>
                                 </Link>
                              </li>

                              <li>
                                 <Link
                                    href="/discover-benzatine/our-work-process"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Our Work Process
                                    </span>
                                 </Link>
                              </li>

                              <li>
                                 <Link
                                    href="/discover-benzatine/our-culture"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Our Culture
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-12 col-md-6">
                     <div className="header__col add-border-left">
                        <div className="border-div">
                           <ul className="list-unstyled">
                              <li>
                                 <Link
                                    href="/discover-benzatine/contact-us"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Contact Us
                                    </span>
                                 </Link>
                              </li>
                              <li>
                                 <Link
                                    href="/discover-benzatine/career-overview"
                                    className="header__col-link"
                                 >
                                    <span className="header__col-link-text">
                                       Career Overview
                                    </span>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="protfoli-menu-wrap add-menu-border mt-3">
                     <div className="menu-box follow-us-div">
                        <h3>follow us on</h3>
                        <div className="d-flex align-items-center justify-content-start gap-3 mt-4 flex-wrap">
                           <a
                              className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                              href="https://www.behance.net/benzatine-infotech"
                              target="_blank"
                           >
                              <img src="/assets/svg/behance.svg" />
                              <span className="follow-us-name">behance</span>
                           </a>
                           <a
                              className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                              href="https://dribbble.com/chirag_vadukia"
                              target="_blank"
                           >
                              <img src="/assets/svg/dribble.svg" />
                              <span className="follow-us-name">dribble</span>
                           </a>
                           <a
                              className="d-flex align-items-center justify-content-center gap-3 flex-column protfoli-mobile-icon"
                              href="https://github.com/bpvadukia"
                              target="_blank"
                           >
                              <img src="/assets/svg/Github.svg" />
                              <span className="follow-us-name">Github</span>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </li>

         <li className="nav-li">
            <div className="mobile-nav-item">
               <Link href="/news-room" className="header__nav-link">
                  News Room
               </Link>
            </div>
         </li>
      </ul>
   )
}
